import axios from "axios";

// Public ordering API client (OrderProduct.md §4) — no auth required.
// Kept on a dedicated axios instance (no Authorization header) so it stays
// independent of the staff Instance used by the rest of the ERP.

// Host of the API. Not under /api/v1 — legacy image paths hang off the root.
export const PUBLIC_HOST = "https://rahelapi.erp-softgroup.link/";

const PublicInstance = axios.create({
    baseURL: PUBLIC_HOST + "/api/v1",
    headers: { "Content-Type": "application/json" }
});

// Resolve one entry of a product's images[] to something an <img src> can use.
// Uploads now land in Contabo object storage and come back as absolute URLs,
// but images uploaded before that switch are still relative paths ("/uploads/
// products/x.jpg") served off the API host, so both forms have to keep working.
export const imageSrc = (img) => {
    if (!img) return "";
    if (/^https?:\/\//i.test(img)) return img;
    return (
        PUBLIC_HOST.replace(/\/+$/, "") + (img.startsWith("/") ? img : "/" + img)
    );
};

// Build the full URL for a product image (first image, with a fallback).
export const publicImageUrl = (product, fallback = "/placeholder.png") => {
    const img = product && product.images && product.images[0];
    return img ? imageSrc(img) : fallback;
};

// List published products. params: { q?, page?, limit? } (limit max 50).
// → { products, page, limit, total, pages }
export const getPublicProducts = async (params = {}) => {
    try {
        const response = await PublicInstance.get("/public/products", { params });
        return response.data;
    } catch (error) {
        console.error("Error fetching public products:", error);
        throw error;
    }
};

// Get one published product by its catalog id.
export const getPublicProduct = async (id) => {
    try {
        const response = await PublicInstance.get(`/public/products/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching public product:", error);
        throw error;
    }
};

// Place a guest order. payload: { customer: { name, phone, address, note? },
// items: [{ productId, quantity, unit? }] }. Pricing is server-side; the
// returned total is authoritative. → { orderNumber, total, currency, status }
export const placePublicOrder = async (payload) => {
    try {
        const response = await PublicInstance.post("/public/order", payload);
        return response.data;
    } catch (error) {
        console.error("Error placing public order:", error);
        throw error;
    }
};

// Track an order — both orderNumber and the checkout phone are required.
export const trackPublicOrder = async (orderNumber, phone) => {
    try {
        const response = await PublicInstance.get("/public/order/track", {
            params: { orderNumber, phone }
        });
        return response.data;
    } catch (error) {
        console.error("Error tracking public order:", error);
        throw error;
    }
};

export default PublicInstance;
